// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__365AG","left":"styles_left__1JNqv"};